import { useQuery } from '@tanstack/react-query';
import { getVideoThumbnailById } from '../shared/helpers';
import type { VideoPlatformType } from '../shared/types';

export default function useVideoThumbnail(id: number | string, platform: VideoPlatformType) {
    return useQuery(['thumbnail', id, platform], () => getVideoThumbnailById(id, platform));
}
